import React, { useState } from 'react';
import {
  InlineEdit,
  InlineEditTableWrapper,
  ApiProgressLoader
} from '@nile/components';
import InlineDependantSelect from '@nile/components/src/Components/InlineEdit/Components/InlineDependantSelect';
import { SVGIcon } from '@superops/super-icons';

let timerId = null;

function InlineEditTextCell(props) {
  const { _ticket, cell, params, editCellId } = props;
  const ticket = _ticket || cell.row.original;
  const {
    actions,
    type,
    editable,
    clearable,
    shouldFreezeCell,
    setEditCell
  } = cell.column;
  const isTechnicianCell = cell.column.id === 'technician';
  const isTriageAgent = cell?.row?.original?.technician?.userId === '14';

  const fieldName = params?.field?.name
    ? params?.field?.name
    : props?.cell?.value?.name
    ? props?.cell?.value?.name
    : '';
  const _field = cell
    ? cell?.row?.values?.[cell?.column?.id] || {}
    : ticket?.[accessor];
  const displayVal =
    _field?.firstName && _field?.lastName
      ? `${_field.firstName} ${_field.lastName}`
      : _field?.firstName
      ? _field.firstName
      : _field?.name
      ? _field.name
      : '';
  const [apiProgress, setApiProgress] = useState(false);
  const [apiResult, setApiResult] = useState(null);
  const setApiComplete = (state) => {
    setApiProgress(false);
    setApiResult(state);
    if (timerId) clearTimeout(timerId);
    timerId = setTimeout(() => {
      setApiResult(null);
    }, 2000);
  };
  const isCellFreezed = shouldFreezeCell && shouldFreezeCell(cell);
  const isEditable = !isCellFreezed && editable;
  if (editCellId && editCellId === cell.id) {
    return (
      <InlineEditTableWrapper
        className="full-width"
        key={ticket?.ticketId || cell?.field?.name || cell?.row?.id}
      >
        <InlineDependantSelect
          {...props}
          mode="edit"
          updateFieldState={(value) => {
            actions.save &&
              actions.save(value, ticket, props.data, setApiComplete);
            setApiProgress(true);
            setEditCell(null);
          }}
          isClearable={clearable}
        />
      </InlineEditTableWrapper>
    );
  }
  return (
    <div className={`flex center full-height mw-100`}>
      <div
        className={`ellipsis self-center flex g5 center inlineSelect full-height max-width-250 ${
          isEditable ? 'editable-cell pointer' : 'cell'
        }`}
        title={displayVal}
        onClick={(e) => {
          if (isEditable) {
            setEditCell(cell.id);
            e.stopPropagation();
            e.preventDefault();
          }
        }}
      >
        {isTechnicianCell && isTriageAgent && (
          <div className="flex">
            <SVGIcon name="TriageAgent" />
          </div>
        )}

        <div className="ellipsis self-center flex center">
          <div className="ellipsis">{displayVal || 'NA'}</div>
        </div>

        {apiProgress && <ApiProgressLoader isLoading />}
        {apiResult && <ApiProgressLoader isSuccess={apiResult === 'success'} />}

        {isEditable && (
          <div className="edit-actions">
            {
              <div className="ml8 fx center">
                <SVGIcon name="Edit" />
              </div>
            }
          </div>
        )}
      </div>
    </div>
  );
}

export default InlineEditTextCell;
